import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { selectHasSelectedCompanyFilterAccess } from 'containers/App/selectors'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { getIncidentsCountError, getIncidentsCountSuccess } from './actions'
import { FETCH_INCIDENTS_COUNT_ASYNC } from './constants'

const getIncidentsCountEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, FETCH_INCIDENTS_COUNT_ASYNC.INITIATE),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    }),
    mergeMap(() =>
      !selectHasSelectedCompanyFilterAccess(state$.value)
        ? of(FETCH_INCIDENTS_COUNT_ASYNC.cancel())
        : api.dashboard
            .getResolutionCenterCounts(state$.value.partnerOptions.selectedCompany?.value)
            .pipe(
              map((response) => getIncidentsCountSuccess(response)),
              catchError((error) => of(epicsErrorHandler(getIncidentsCountError, error)))
            )
    )
  )

export default combineEpics(getIncidentsCountEpic)
